import type { Block } from 'blockly/core';

import { arduinoGenerator, blockTraceComment, Order } from './arduino-generator.js';
import { ensureBeginnerSerialSetup } from './beginner-serial.js';

function statementPrefix(block: Block, code: string): string {
  return `${blockTraceComment(block)}\n${code}`;
}

export function registerBeginnerSerialMonitorGenerators(): void {
  arduinoGenerator.forBlock['beginner_serial_send'] = (block: Block) => {
    ensureBeginnerSerialSetup();
    const value = arduinoGenerator.valueToCode(block, 'VALUE', Order.NONE) || '""';
    return statementPrefix(block, `Serial.print(${value});\n`);
  };

  arduinoGenerator.forBlock['beginner_serial_send_character'] = (block: Block) => {
    ensureBeginnerSerialSetup();
    const charValue = arduinoGenerator.valueToCode(block, 'CHAR', Order.NONE) || "'A'";
    return statementPrefix(block, `Serial.write(${charValue});\n`);
  };

  arduinoGenerator.forBlock['beginner_serial_send_line'] = (block: Block) => {
    ensureBeginnerSerialSetup();
    const value = arduinoGenerator.valueToCode(block, 'VALUE', Order.NONE) || '""';
    return statementPrefix(block, `Serial.println(${value});\n`);
  };

  arduinoGenerator.forBlock['beginner_serial_received_character'] = () => {
    ensureBeginnerSerialSetup();
    return ['static_cast<char>(Serial.read())', Order.FUNCTION_CALL];
  };

  arduinoGenerator.forBlock['beginner_serial_received_number'] = () => {
    ensureBeginnerSerialSetup();
    return ['Serial.parseFloat()', Order.FUNCTION_CALL];
  };

  arduinoGenerator.forBlock['beginner_serial_received_text'] = () => {
    ensureBeginnerSerialSetup();
    return ["Serial.readStringUntil('\\n')", Order.FUNCTION_CALL];
  };

  arduinoGenerator.forBlock['beginner_serial_data_available'] = () => {
    ensureBeginnerSerialSetup();
    return ['(Serial.available() > 0)', Order.RELATIONAL];
  };

  arduinoGenerator.forBlock['beginner_serial_wait_data'] = (block: Block) => {
    ensureBeginnerSerialSetup();
    return statementPrefix(block, 'while (Serial.available() == 0) {\n}\n');
  };
}

registerBeginnerSerialMonitorGenerators();
